import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Form, Row, Button, Table, Spinner } from 'react-bootstrap';
import Moment from "moment";
import { toast } from 'react-toastify';
import { getClientSubscriptionListAPI, sendRenewSubscriptionMailAPI } from 'actions/Subscription/subscribtionlistAction';
import TablePagination from 'components/common/TablePagination';
import loader from '../../assets/img/loader.svg'

export const SubscriptionDetails = () => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);

	const [caseScheduleList, setSubscriptionList] = useState([]);
	const [pageNumber, setPageNumber] = useState(1);

	const [pageSize, setPageSize] = useState(5);
	const [subscriptionCount, setSubscriptionCount] = useState(0);

	const advocateName = localStorage.getItem('LoginUserName');
	const advocateCode = localStorage.getItem('EncryptedAdvocateCode');
	let pageCount = Math.ceil(subscriptionCount / pageSize);
	const isPreviousDisabled = pageNumber === 1;
	const isNextDisabled = pageNumber === pageCount;
	let token = localStorage.getItem('Token') || sessionStorage.getItem('Token');
	const headers = {
		Authorization: `Bearer ${JSON.parse(token).value}`
	};


	useEffect(() => {
		fetchSubscriptionList(pageNumber, pageSize)
	}, [])

	const fetchSubscriptionList = async (newPageNumber, newPageSize) => {
		let requestData = {
			EncryptedAdvocateCode: localStorage.getItem("EncryptedAdvocateCode"),
			PageNumber: newPageNumber ? newPageNumber : pageNumber,
			PageSize: newPageSize ? newPageSize : pageSize,
		}
		setIsLoading(true);

		await dispatch(
			getClientSubscriptionListAPI(
				requestData,
				res => {
					if (res.data.data.clientSubcription.length > 0) {
						setIsLoading(false);
						setSubscriptionList(res.data.data.clientSubcription)
						setSubscriptionCount(res.data.data.totalCount)
					} else {
						setIsLoading(false);
						setSubscriptionList([])
						setTimeout(function () {
							$('#no-subscription-message').html('No records found!');
						}, 100)
					}
				},
				err => {
					setIsLoading(false);
					setSubscriptionList([])
					setTimeout(function () {
						$('#no-subscription-message').html('No records found!');
					}, 100)
					console.log(err?.data.message);
				},
				headers
			)
		);
	}
	const advocateValidate = () => {
		if (!advocateCode) {
			toast.error("Advocate code not available", {
				theme: 'colored',
				autoClose: 10000
			});
			return false;
		}
		return true;
	};
	const sendEmail = () => {
		if (advocateValidate()) {
			setIsLoading(true);
			dispatch(
				sendRenewSubscriptionMailAPI(
					localStorage.getItem(
						'EncryptedAdvocateCode')
					,
					(response) => {
						setIsLoading(false)
					},
					(err) => {
						console.log(err?.message)
						setIsLoading(false)
					},
					headers 
				)
			);
		}
	}
	const onPageClick = async ({ selected }) => {
		setPageNumber(selected + 1);
		fetchSubscriptionList(selected + 1)
	}

	const handlePageSize = async (e) => {
		setPageSize(e.target.value);
		setPageNumber(1);
		fetchSubscriptionList(1, e.target.value)
	}

	const handlePreviousClick = async () => {
		setPageNumber(pageNumber - 1);
		fetchSubscriptionList(pageNumber - 1)
	}

	const handleNextClick = async () => {
		setPageNumber(pageNumber + 1);
		fetchSubscriptionList(pageNumber + 1)
	}
	return (
		<>
			{/* {isLoading ? (
				<Spinner
	  className="loader-color popup-loader position-fixed top-50 start-50 translate-middle z-index-5"
          // className="position-absolute start-50 loader-color"
					animation="border"
				/>
			) : null} */}
			      {isLoading ? (
  <img
    src={loader}
    alt="Loading..."
    className="loader-gif position-fixed top-50 start-50 translate-middle z-index-5"
  />
) : null}

			<Form className="details-form Subscription-Detail CaseScheduleDetailDashboard1" id="CaseScheduleDetailDashboard">
  <Row className="justify-content-between align-items-center casSchedule-button mb-3">
    <Col className="col-12 col-md-5 text-start mb-2 mb-md-0">
      <h4 className='advocate-Name'>{advocateName}</h4>
    </Col>
    <Col className="col-12 col-md-5 text-end">
      <Button onClick={() => sendEmail()}>
        Sent Message For Renewal
      </Button>
    </Col>
  </Row>

  <div className="case-schedule-table-container">
    {caseScheduleList && caseScheduleList.length > 0 ? (
      <Row className="no-padding">
        <Table striped bordered responsive className="table-md overflow-hidden case-schedule-table">
          <thead className='custom-bg-200 case-schedule-thead'>
            <tr>
              <th>S. No</th>
              <th>Subscription Start Date</th>
              <th>Subscription End Date</th>
              <th>Subscription Total Amount</th>
            </tr>
          </thead>
          <tbody>
            {caseScheduleList.map((data, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{Moment(data.startDate).format('DD-MMM-YYYY')}</td>
                <td>{Moment(data.expiryDate).format('DD-MMM-YYYY')}</td>
                <td>{data.totalAmount}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Row>
    ) : (
      <Row className='justify-content-center mt-2'>
        <Col className='col-auto'>
          <h4 id="no-subscription-message"></h4>
        </Col>
      </Row>
    )}
  </div>
</Form>
<div className='customer-inq-pagination'>
<Row style={{ position: 'absolute', bottom: '30px', Align: 'center' }}>
  <TablePagination
    pageCount={pageCount}
    handlePageClick={onPageClick}
    pageSize={pageSize}
    handlePageSizeChange={handlePageSize}
    isDisablePrevious={isPreviousDisabled}
    isDisableNext={isNextDisabled}
    previousClick={handlePreviousClick}
    nextClick={handleNextClick}
    pageIndex={pageNumber - 1}
  />
</Row>
</div>
		</>
	)
}